export const getDocumentCreatedSelector = (state) =>
  state.documentsReducer.documentCreated;

export const getDocumentsSelector = (state) => state.documentsReducer.documents;
